import { createAction, createAsyncThunk } from "@reduxjs/toolkit"
import { MapSnapshotProps } from "@nova/component-map-snapshot"
import { createAppThunk } from "integrations/redux/hooks"
import { resetOverlayAction } from "features/content-overlay/slice"
import { setInviteModalId } from "features/entity-caching/members/UserManagementSlice"

const sliceName = "runlevel"
const asActionTypeName = (action: string) => `${sliceName}/${action}`

export const showGlobalModal = createAction(asActionTypeName("showGlobalModal"))
export const hideGlobalModalEffect = createAction(asActionTypeName("hideGlobalModal"))
export const hideGlobalModal = createAppThunk((_, { dispatch }) => {
    dispatch(hideGlobalModalEffect())
    dispatch(resetOverlayAction())
    dispatch(setInviteModalId(undefined))
})

type SnapshotHandlers = Pick<MapSnapshotProps, "onConfirm" | "onCancel">
// isn't this state outside of the redux slice?
// yes - the redux slice should only hold onto serializable data, and functions aren't that
// so we stash them up here
// more robust solutions to investigate when we move to routing:
// - snapshot using portals
// - react hook / global event emitter
let currentSnapshotState: SnapshotHandlers | undefined
export const getSnapshotState = () => currentSnapshotState
export const snapshot = createAsyncThunk(
    `${sliceName}/start-snapshot`,
    async (payload: SnapshotHandlers) => {
        return new Promise<void>((resolve, reject) => {
            currentSnapshotState = {
                onConfirm: (r) => {
                    currentSnapshotState = undefined
                    if (payload.onConfirm) {
                        payload.onConfirm(r)
                    }
                    resolve()
                },
                onCancel: () => {
                    currentSnapshotState = undefined
                    if (payload.onCancel) {
                        payload.onCancel()
                    }
                    reject()
                },
            }
        })
    }
)
